<template>
  <div class="fragebogenVorschau">
    <FragebogenModule
      :fragebogenIdentifier="fragebogenIdentifier"
      :bearbeitbar="false"
    >
    </FragebogenModule>
    <div class="fragebogenButtons">
      <v-row>
        <v-col>
          <b-btn @click="ladeProjektDetails()"> zurück </b-btn>
        </v-col>
        <v-col cols="auto">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <b-btn
                v-on="on"
                :loading="laedt"
                :disabled="laedt || versendet"
                @click="pruefeVersendet()"
              >
                Versenden
              </b-btn>
            </template>
            <span>{{ tooltips.email_versenden }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
    <BestaetigenPopup
        v-if="zeigeBestaetigenPopup"
        infoText="Der Fragebogen wurde bereits versendet. Sind sie sich sicher, dass sie den Fragebogen erneut versenden wollen?"
        @cancel="zeigeBestaetigenPopup = false"
        @confirm="fragebogenVersenden()"
    />
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import dataMixin from '@/mixins/data-mixin';
import FragebogenModule from '@/views/fragebogen/FragebogenModule';
import _ from 'lodash';
import axios from 'axios';
import tooltips_text from '@/utils/data/tooltips';
import BestaetigenPopup from '@/components/popups/BestaetigenPopup';

export default {
  name: 'FragebogenVorschau',
  components: { FragebogenModule, BestaetigenPopup },
  props: {
    uuid: {
      type: [Number, String],
    },
  },
  data() {
    return {
      fragebogenIdentifier: {
        typ: 'fragebogen/zwischenstand?',
        parameter: {
          id: this.uuid,
          position: 1,
        },
      },
      tooltips: tooltips_text,
      snackbar: {
        show: false,
        color: '',
        text: '',
        timeout: 4000,
      },
      laedt: false,
      zeigeBestaetigenPopup: false,
      versendet: false,
    };
  },
  computed: {
    oeffneSnackbarErfolg() {
      return (response) => {
        if (200 <= response.statusCode < 300) {
          this.snackbar.color = `primary`;
          this.snackbar.text = `Erfolgreich versendet`;
          this.snackbar.show = true;
          this.laedt = false;
        }
      };
    },
    oeffneSnackbarFehlschlag() {
      return (err) => {
        this.snackbar.color = `red`;
        this.snackbar.text = `${err.response.status} Fehler beim versenden`;
        this.snackbar.show = true;
        this.laedt = false;
      };
    },
  },
  mixins: [
    //ProjektStammdaten
    dataMixin('projektleiter', 'persistentData.projekt.projektLeiter'),
    dataMixin('fragebogen', 'loadedData.fragebogen'),
  ],
  methods: {
    pruefeVersendet() {
      if (this.versendet || this.fragebogen.versendet) {
        this.zeigeBestaetigenPopup = true;
      } else {
        this.fragebogenVersenden();
      }
    },
    fragebogenVersenden() {
      this.laedt = true;
      const benutzerDatenDTO = {
        email: this.projektleiter.email,
        nachname: this.projektleiter.nachname,
        vorname: this.projektleiter.vorname,
        anrede: this.projektleiter.anrede,
        titel: this.projektleiter.titel,
      };
      const fragebogenDTO = _.cloneDeep(this.fragebogen);
      fragebogenDTO.abgeschickt = true;

      const mailInfo = {
        benutzerDatenDTO: benutzerDatenDTO,
        fragebogenDTO: fragebogenDTO,
      };
      axios
        .post(`/v1/fragebogen/ERSTSENDUNG/${this.fragebogen.id}`, mailInfo)
        .then(
          (response) => {
            this.versendet = true;
            this.oeffneSnackbarErfolg(response);
            setTimeout(() => {  this.versendet = false; }, 120000);
          },
          (err) => this.oeffneSnackbarFehlschlag(err)
        );
    },
    ladeProjektDetails() {
      this.$router.push('/projekt/' + this.fragebogen.projektId);
    },
  },
};
</script>
<style lang="scss" scoped>
.fragebogenUebersicht {
  padding-bottom: 60px;
  h2 {
    margin-bottom: 20px;
  }
  .fragebogenButtons {
    float: right;
  }
}
</style>
